import { TZDateMini } from '@date-fns/tz';
import { notifyBugsnag } from 'cfa-react-logging';
import { addMinutes, constructNow, format, parse } from 'date-fns';
import ooeConstants from '../constants';
import { HoursOfOperation } from '../types/location';

export const pullOutHours = (hoursOfOperation: HoursOfOperation) => {
  const { monday, tuesday, wednesday, thursday, friday, saturday } = hoursOfOperation;
  const arrOfDays = [
    { day: 'Monday', hours: monday },
    { day: 'Tuesday', hours: tuesday },
    { day: 'Wednesday', hours: wednesday },
    { day: 'Thursday', hours: thursday },
    { day: 'Friday', hours: friday },
    { day: 'Saturday', hours: saturday },
  ];
  return arrOfDays.map((dayOfWeek) => {
    let blackoutHours = null;
    if (dayOfWeek.hours?.blackoutHours) {
      const { openTime } = dayOfWeek?.hours?.blackoutHours;
      const { durationInMinutes } = dayOfWeek?.hours.blackoutHours;
      const parsedOpenTime = parse(openTime, ooeConstants.DATE_TIME_FORMAT.time, new Date());
      const formatedOpenTime = format(parsedOpenTime, ooeConstants.DATE_TIME_FORMAT.timeAmPm);
      const endTime = format(
        addMinutes(parsedOpenTime, durationInMinutes),
        ooeConstants.DATE_TIME_FORMAT.timeAmPm,
      );
      blackoutHours = `- ${formatedOpenTime} ${endTime} -`;
    }
    if (dayOfWeek.hours?.operationType === 'closed') {
      return `${dayOfWeek.day}: Closed`;
    }
    if (dayOfWeek.hours?.operationType === 'open24Hours') {
      return `${dayOfWeek.day}: ${blackoutHours ? `12:00 AM ${blackoutHours} 12:00 PM` : 'Open 24h'}`;
    }
    if (dayOfWeek.hours?.operationType === 'standardHours') {
      const { openTime, durationInMinutes } = dayOfWeek?.hours?.operatingInterval || {
        openTime: '',
        durationInMinutes: 0,
      };
      const parsedOpenTime = parse(openTime, ooeConstants.DATE_TIME_FORMAT.time, new Date());
      const formatedOpenTime = format(parsedOpenTime, ooeConstants.DATE_TIME_FORMAT.timeAmPm);
      const endTime = format(
        addMinutes(parsedOpenTime, durationInMinutes),
        ooeConstants.DATE_TIME_FORMAT.timeAmPm,
      );
      return `${dayOfWeek.day}: ${formatedOpenTime} ${blackoutHours || '-'} ${endTime}`;
    }
    return `${dayOfWeek.day}: Closed`;
  });
};

export const formatRestaurantLocalTime = (timezone: string) => {
  try {
    if (typeof timezone !== 'string' || timezone.trim() === '') {
      throw new Error(`Invalid timezone: ${timezone}`);
    }
    return format(constructNow(TZDateMini.tz(timezone)), ooeConstants.DATE_TIME_FORMAT.timeAmPm);
  } catch (error: unknown) {
    notifyBugsnag({
      grouping: 'formatRestaurantLocalTime',
      message: 'Invalid Timezone',
      error,
    });
    return 'Timezone information could not be reached at this time.';
  }
};
